import React from "react";

import {
  TrialSummary as TrialSummaryType,
} from "./dashboardType"

interface Props {
  data: TrialSummaryType;
}

const TrialSummary: React.FC<Props> = ({
  data,
}) => {
  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Trials
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <div>
          <p className="text-sm text-gray-500">
            Total Trials
          </p>
          <p className="text-xl font-bold">
            {data.Total_Trials}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Active
          </p>
          <p className="text-xl font-bold">
            {data.Active_Trials}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Expired
          </p>
          <p className="text-xl font-bold">
            {data.Expired_Trials}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Converted
          </p>
          <p className="text-xl font-bold">
            {data.Converted}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Not Converted
          </p>
          <p className="text-xl font-bold">
            {data.Not_Converted}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Conversion Rate
          </p>
          <p className="text-xl font-bold">
            {data.Conversion_Rate}%
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Trial Days
          </p>
          <p className="text-xl font-bold">
            {data.Trial_Days}
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrialSummary;